module.exports = __webpack_public_path__ + "img/folder.43354ccb.svg";